export default __webpack_public_path__ + "static/checkout-dashboard-89d8b2fe9edbbc574811ec04cc8c2a28.png";